/* https://github.com/New-Bamboo/example-ajax-upload/blob/master/public/index.html */

import removeAnchorFromUrl from '../functions/removeAnchorFromUrl';
import ajaxUploadProgress from '../functions/ajaxUploadProgress';
import customEvent from '../functions/customEvent';
import { CSRF_TOKEN_ATTR } from '../functions/xhrLoad';
import { querySelector } from '../functions/querySelectors';
import { BEFORE_SUBMIT_EVENT, EVENT_URL } from '../config/main';

const FORM_CLASS = 'w-form';
const FORM_SUBMITTING_CLASS = 'w-form--submitting';
const FORM_SUBMITTING_FILE_CLASS = 'w-form--with-file';
const FORM_INNER_CLASS = 'w-form__form';
const PROGRESS_CLASS = 'w-form__progress';

let getGetUrl = function(form, formData) {
  return removeAnchorFromUrl(form.getAttribute('action')) + formatParams(formData, form);
};

let formatParams = function(formData, form) {
  var firstRun = form.getAttribute('action').indexOf('?') === -1;
  let ret = '';
  let keys = formData.keys();

  //ie11 hack
  if (!formData.keys()[Symbol.iterator]() === formData.keys()) {
    keys = [...formData.keys()];
  };

  for (var key of keys) {
    if (firstRun) {
      ret += '?';
      firstRun = false;
    }
    else {
      ret += '&';
    }

    ret += `${key}=${formData.get(key)}`;
  }

  return ret;
};

let initAjaxSubmit = function(form) {
  let progressElement;
  let formWrapper;

  let sendUrl = function(event) {
    event.preventDefault();

    // eslint-disable-next-line no-undef
    let formData = new FormData(form);

    sendXHRequest(formData, form, event.detail.newUrl);

    return false;
  };

  let onSubmit = function(event) {
    event.preventDefault();

    // eslint-disable-next-line no-undef
    let customEvent = new CustomEvent(BEFORE_SUBMIT_EVENT, {
      cancelable: true // without that flag preventDefault doesn't work
    });

    if (form.dispatchEvent(customEvent)) {
      // eslint-disable-next-line no-undef
      let formData = new FormData(form);

      sendXHRequest(formData, form);

      return false;
    }
  };

  let sendXHRequest = function(formData, form, getUrl = null) {
    let isGet = form.getAttribute('method').toLowerCase() === 'get';
    setSubmittingForm();

    // eslint-disable-next-line no-undef
    let xhr = new XMLHttpRequest();

    xhr.upload.addEventListener('loadstart', onloadstartHandler, false);
    xhr.upload.addEventListener('progress', onprogressHandler, false);
    xhr.upload.addEventListener('load', onloadHandler, false);
    xhr.addEventListener('readystatechange', onreadystatechangeHandler, false);

    if (isGet) {
      if (!getUrl) {
        getUrl = getGetUrl(form, formData);
      }

      customEvent(form, 'changeUrl', {detail: {newUrl: getUrl}});
      xhr.open('get', getUrl, true);
    }
    else {
      xhr.open('post', form.getAttribute('action'), true);
    }

    xhr.setRequestHeader('X-CSRF-Token', document.body.getAttribute(CSRF_TOKEN_ATTR));
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    if (isGet) {
      xhr.send();
    }
    else {
      xhr.send(formData);
    }
  };

  let onloadstartHandler = function() {
  };

  let onloadHandler = function() {
  };

  let onprogressHandler = function(event) {
    submittingProgress(Math.round(event.loaded / event.total * 100));
  };

  let setSubmittingForm = function() {
    if (form.parentNode.classList.contains(FORM_CLASS)) {
      formWrapper = form.parentNode;
    }
    else {
      formWrapper = document.createElement('div');
      formWrapper.classList.add(FORM_CLASS);
      form.parentNode.insertBefore(formWrapper, form);
      formWrapper.appendChild(form);
    }

    form.classList.add(FORM_INNER_CLASS);
    formWrapper.classList.add(FORM_SUBMITTING_CLASS);

    if (querySelector('input[type="file"]', form)) {
      formWrapper.classList.add(FORM_SUBMITTING_FILE_CLASS);
    }

    let progressWrap = document.createElement('div');
    progressWrap.classList.add(PROGRESS_CLASS);
    progressWrap.innerHTML = '<span></span>';

    formWrapper.appendChild(progressWrap);
    submittingProgress(0);
  };

  let removeSubmittingForm = function() {
    formWrapper.classList.remove(FORM_SUBMITTING_CLASS);
    formWrapper.classList.remove(FORM_SUBMITTING_FILE_CLASS);
    let progressWrap = querySelector(`.${PROGRESS_CLASS}`, formWrapper);

    if (progressWrap) {
      progressWrap.parentNode.removeChild(progressWrap);
    }
  };

  let submittingProgress = function(progress) {
    if (progressElement) {
      progressElement.style.width = `${progress}%`;
    }
    else {
      progressElement = querySelector(`.${PROGRESS_CLASS} span`, formWrapper);
    }
  };

  let onreadystatechangeHandler = function(event) {
    let status;
    let text;
    let readyState;
    let customEvent;

    try {
      readyState = event.target.readyState;
      text = event.target.responseText;
      status = event.target.status;
    }
    catch (event) {
      return;
    }

    if (readyState === 4) {
      let options = {
        detail: {
          response: text
        }
      };

      if (status === 200 && text) {
        if (text === 'errorERROR' || text === 'ERROR') {
          // eslint-disable-next-line no-undef
          customEvent = new CustomEvent('formError', options);
        }
        else {
          // eslint-disable-next-line no-undef
          customEvent = new CustomEvent('formSuccess', options);
        }
      }
      else if (status === 404 || status === 500) {
        // eslint-disable-next-line no-undef
        customEvent = new CustomEvent('formError', options);
      }

      if (customEvent) {
        form.dispatchEvent(customEvent);
      }
      removeSubmittingForm();
    }
  };

  //  init submit
  form.onsubmit = onSubmit;
  form.addEventListener(EVENT_URL, sendUrl);
};

export default function(formElement) {
  if (ajaxUploadProgress()) {
    initAjaxSubmit(formElement);
  }
  else {
    // skryti formulare pro prohlizece, ktere nepodporujeme
    formElement.style.display = 'none';
  }
};
